import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/api/config';
import { axios } from '@/lib/axios/axios';
import { MutationConfig } from '@/lib/react-query/react-query';

const url = `${PREFIX_URL}/legal-center/terms-and-conditions`;

type UpdateTermsAndConditionsResponse = { status: boolean };

export const updateTermsAndConditions = ({
  content,
}: {
  content: string;
}): Promise<UpdateTermsAndConditionsResponse> => {
  return axios.post(url, { content }, { showError: false });
};

type UseUpdateTermsAndConditionsOptions = {
  config?: MutationConfig<typeof updateTermsAndConditions>;
};

export const useUpdateTermsAndConditions = ({
  config,
}: UseUpdateTermsAndConditionsOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: ({ content }) => updateTermsAndConditions({ content }),
  });
};
